export default __webpack_public_path__ + "static/media/elevate-bpn-1.135b94ae.png";